import moment from 'moment'
import { IEquipmentTypes, Maybe } from 'types/graphqlTypes'
import { getLaneText } from 'apps/marketplace/utils/helpers/getLaneText'
import { ShipperRateObjectAugmented } from 'apps/marketplace/utils/hooks/AwardedLanes/useAwardedLanesApi'
import { IAwardedLaneFragment } from '../graphql/AwardedLaneFragment'
import { getLoadType } from './getLoadType'

// Transforms `08-19-2022T00:00:00` to `08-19-2022`
export const getDate = (dateTime: Maybe<string>): string => {
  const dateMatch = (dateTime || '').match(/(\d+-*)*T/g) || []
  return (dateMatch[0] || '').replace('T', '')
}

export const getAugmentedRate = (awardedLane: IAwardedLaneFragment): ShipperRateObjectAugmented => {
  const {
    carrierMarketRate,
    carrierSalesRep,
    datMiles,
    deliveryCity,
    deliveryRegion,
    deliveryStateCode,
    endDate,
    equipment,
    id,
    isDeliveryDropTrailer,
    isPickupDropTrailer,
    pickupCity,
    pickupRegion,
    pickupStateCode,
    requestForProposalLaneFeedback,
    shipperApplication,
    shipperLaneId,
    sourceStatus,
    sourcedCarrierRatesCount,
    startDate,
    volume,
    volumeType,
    weeklyVolume,
  } = awardedLane
  const { requestForProposalLanePrice, tttAtAward } = requestForProposalLaneFeedback ?? {}
  const { requestForProposalLane, tfxhAllIn } = requestForProposalLanePrice ?? {}
  const { googleSheetsUrl, salesforceRfpId } = requestForProposalLane?.requestForProposal ?? {}
  const durationInMonths = moment(endDate).diff(moment(startDate), 'months')

  return {
    id: Number(id),
    carrierSalesRep: carrierSalesRep
      ? {
          id: Number(carrierSalesRep.id),
        }
      : undefined,
    salesRepName: carrierSalesRep?.fullName ?? 'Unassigned',
    datMiles,
    monthDuration: durationInMonths,
    delivery: {
      region: deliveryRegion,
    },
    endDate: getDate(endDate),
    equipment: equipment
      ? {
          id: Number(equipment.id),
          key: IEquipmentTypes[equipment.key],
          name: equipment.name,
          parentId: Number(equipment.parent?.id),
        }
      : undefined,
    googleSheetsUrl,
    lane: getLaneText(
      {
        city: pickupCity,
        stateCode: pickupStateCode,
      },
      {
        city: deliveryCity,
        stateCode: deliveryStateCode,
      },
      '-'
    ),
    pickup: {
      region: pickupRegion,
    },
    loadType: getLoadType(isPickupDropTrailer, isDeliveryDropTrailer),
    rfpFeedback: {
      tfxhAllIn: String(tfxhAllIn),
      tttAtAward,
    },
    carrierTargetRates: {
      transfixCostPrediction40thPercentile: carrierMarketRate,
    },
    salesforceRfpId,
    sourcedCarrierRateCount: sourcedCarrierRatesCount,
    shipperApplication: {
      id: Number(shipperApplication.id),
      name: shipperApplication.name,
    },
    shipperLaneId,
    sourceStatus,
    startDate: getDate(startDate),
    volume,
    volumeType,
    volumeConversions: {
      weeklyVolume,
    },
  }
}
